import { useMemo } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Marker, Popup, useMapEvents } from "react-leaflet";
import { divIcon, DomEvent } from "leaflet";

import { Box, Button, Card, Stack, Typography } from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { changePointPosition, removePoint } from "Redux/pointsSlice";

const ICON_SIZE = 16;

export default function Points() {
  const dispatch = useAppDispatch();

  const { points } = useAppSelector((state) => state.points);

  const map = useMapEvents({});

  const handleRemovePoint = (index: number) => {
    map.closePopup();
    setTimeout(() => {
      dispatch(removePoint(index));
    }, 100);
  };

  const pointsMarker = useMemo(() => {
    return points.map((point, index) => {
      const iconMarkup = renderToStaticMarkup(
        <Box
          style={{
            width: `${ICON_SIZE}px`,
            height: `${ICON_SIZE}px`,
            backgroundColor: "#fff",
            borderRadius: "50%",
            border: "3px solid #333",
          }}
        />
      );
      const icon = divIcon({
        html: iconMarkup,
        iconAnchor: [ICON_SIZE / 2, ICON_SIZE / 2],
      });

      return (
        <Marker
          key={point.id}
          position={[point.lat, point.lng]}
          icon={icon}
          draggable={!point.stationId}
          zIndexOffset={2}
          eventHandlers={{
            click: (e) => {
              DomEvent.stopPropagation(e);
            },
            dragend(e) {
              const position = { ...e.target._latlng };
              dispatch(changePointPosition({ point: { ...position }, index }));
            },
          }}
        >
          <Popup interactive closeButton={false} offset={[0, -20]}>
            <Card sx={{ p: 0.5, width: "200px" }}>
              <Button fullWidth size="large" color="black" onClick={() => handleRemovePoint(index)}>
                <Stack direction="row-reverse" alignItems="center" sx={{ width: "100%" }}>
                  <DeleteOutlineOutlinedIcon sx={{ position: "relative !important", mr: "10px !important" }} />
                  <Typography sx={{ fontSize: "16px !important", margin: "0 !important" }}>حذف نقطه</Typography>
                </Stack>
              </Button>
            </Card>
          </Popup>
        </Marker>
      );
    });
  }, [points]);

  return <>{pointsMarker}</>;
}
